import React  from 'react';
import DateComponentProto from './date-proto';


export default function renderDateInFormNew(id, props) {
    return <DateComponentProto renderMode="form-new" id={id} {...props} />;
}